export default {
  path: '/learn',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "index",
    },
    {
      path: "index",
      component: () => import('../components/learn/Index'),
    },
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/learn.js